<template>
    <ui-crud title="Callbacks" subtitle="Manage callbacks." :fetch="fetch" :pipe-with="pipeItems" group-by="status">

        <!-- Filters. -->
        <template #filters="{ debouncedRefresh }">
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="`Callback #${item.id}`"
                :subtitle="item.package_name"
                :metadata="item.opened_at"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <callback-page-form :package-id="packageId" :add-item="addItem"></callback-page-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode, removeItem }">
            <callback-page-form :package-id="packageId" :item="selectedItem" :edit="setEditMode"
                                :remove-item="removeItem"></callback-page-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem }">
            <callback-page-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem"></callback-page-show>
        </template>
    </ui-crud>
</template>

<script>
import {sortBy} from "lodash";
import {Callback} from '@models'

export default {
    props: {
        packageId: null,
    },
    data() {
        return {
            search: '',
        }
    },
    methods: {
        async fetch() {
            return await Callback.all(this.packageId)
        },
        pipeItems(items) {
            items = items.filter(item =>
                item.description.toLowerCase().includes(this.search.toLowerCase()) ||
                `${item.id}`.toLowerCase().includes(this.search.toLowerCase())
            )

            return sortBy(items, callback => callback.status === 'Opened' ? 0 : 1)
        },
    }
}
</script>
